import React from 'react';
import '../css/App.scss';

const NotFound = () => (
    <div className="NotFound">
        <h2>Not Found!</h2>
    </div>
);

export default NotFound;